import React from 'react'
import {get} from 'lodash'
import { format } from 'date-fns';
import StripeCCForm from '~/components/StripeCCForm'
import verifiedImg from './images/verified.png'
import getSymbolFromCurrency from 'currency-symbol-map'
import getPriceFormat from "~/tools/getPriceFormat"
import { StripeJS } from '~/views/Popup/views/CreateSubscription/Billing/StripeCCForm/StripeJS';
import './style.css'

export default class Form extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fields: props.fields
    }
  }
  getVal(key){
    return get(this.props.metadataMap, key)
 }

  async componentDidMount() {
    await StripeJS()
  }

  render() {
    return (
      <form
        onSubmit={ e => this.onStripeSubmit(e) }
        className="popup-stripe-cc-form">
        <StripeCCForm
          buttonCaption="Subscribe Now!"
          formRef={ el => this.stripeFormEl = el }
          onReady={ b => this.onStripeReady(b) }
          apiKey={ ((window.settings.paymentProviders || {}).stripe || {}).apiKey }
          fields= {this.state.fields}
          leftContent={(
            <div className="verification-banner">
              <img alt="Verification" src={ verifiedImg } role="presentation" />
            </div>
          )}
          rightContent={ this.stripeButtons() }
          // stripeLoading={ this.state.stripeLoading } 
          {...this.props}
          />
      </form>
    )
  }

  stripeButtons() {
    const { plan } = this.props
    const pd = plan && plan.planDetails && plan.planDetails[0] || null
    let expiration = this.props.firstPayment && format(this.props.firstPayment.nextBillingDate, "MM/DD/YYYY") || ''
    let legalVerbiage = this.getVal('billingAcceptVerbiage')
    let priceFormat = pd && getPriceFormat(pd, plan) || 'N/A'
    legalVerbiage= legalVerbiage && legalVerbiage.replace(/\[deadline\]/g, expiration)
    legalVerbiage= legalVerbiage && legalVerbiage.replace(/\[price\]/g, priceFormat)
    return (
      <div>
        {this.props.moduleSettings && this.props.moduleSettings.legalVerbiageCheck && <div className="displayFlex">
             <div className="billingVerbiageCheck">
              <input 
                name="billingLegalCheck"
                type="checkbox" 
                id="billingLegalCheck" 
                onClick={() => this.setState({
                  isbillingLegalChecked:!this.state.isbillingLegalChecked, 
                  alert:null
                })}                  
              />  
            </div>
          <div className="legal-texts" dangerouslySetInnerHTML={{__html: legalVerbiage}} />
        </div>}
        { this.state.alert && <div className="alert">{ this.state.alert }</div> }
        <input
          className={
            'button continue-button' +
            (this.state.stripeIsReady ? ' cta' : '') +
            (this.state.stripeLoading ? ' disabled' : '')
          }
          type="submit"
          ref={ el => this.submitButton = el }
          value={ this.state.stripeLoading ? (`${this.props.processingCaption}`|| 'Processing')+'...' : (this.props.submitCaption || 'Continue') } 
        />
      </div>
    )
  }

  onStripeReady(e) {
    this.setState({ stripeIsReady: e })
  }

  onStripeSubmit(e) {
    e.preventDefault()
    const billingCheckEle = document.getElementById('billingLegalCheck')

    if(billingCheckEle){
      const billingCheck = billingCheckEle.checked
      if (!billingCheck){
        this.alert(this.getVal('acceptBillingTermError') || 'Please accept term of use.')
        return
      }
    }


    this.setState({ stripeLoading: true })
    var stripeObj = this.stripeFormEl.props.stripe;
    this.stripeFormEl
      .createToken()
      .then(p => this.props.onToken(p, stripeObj))
      .catch(e => {
        this.alert(
        (((e || {}).response || {}).data || {}).message || e.message || 
        'There was an error processing your request.'
        );
        this.setState({ stripeLoading: false })
      })
  }

  alert(msg) {
    this.setState({ alert: msg })
    setTimeout( _ => this.setState({ alert: null }), 4000 )
  }
}